import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const fieldBase =
  "w-full rounded-lg border border-studio-border bg-studio-card text-sm text-studio-ink outline-none transition-all placeholder:text-studio-faint focus:border-studio-accent/60 focus:shadow-glow-sm disabled:cursor-not-allowed disabled:opacity-50";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn(fieldBase, "h-11 px-3.5 text-base sm:h-10 sm:text-sm", className)} {...props} />
  )
);
Input.displayName = "Input";

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(fieldBase, "resize-none px-3.5 py-3 text-base leading-relaxed sm:text-sm", className)}
      {...props}
    />
  )
);
Textarea.displayName = "Textarea";
